/**
 * Platform vs institute branding — keep Super Admin panel isolated from institute context.
 */

const SUPERADMIN_LOGO_TEXT = "ERP Super Admin";
const PLATFORM_PRIMARY = "#1976d2";

export function isSuperAdminRole(userRole) {
  const r = String(userRole || "").toLowerCase().trim();
  return r === "superadmin" || r === "super admin";
}

/**
 * True when UI should use platform (super admin) branding, not institute branding.
 */
export function shouldUsePlatformBranding({
  userRole,
  isInInstituteContext = false,
  pathname = "",
}) {
  if (!isSuperAdminRole(userRole)) return false;
  if (isInInstituteContext) return false;
  const path = String(pathname || "");
  if (path.startsWith("/superadmin")) return true;
  return !isInInstituteContext;
}

export function getPlatformBranding() {
  return { logoText: SUPERADMIN_LOGO_TEXT, primaryColor: PLATFORM_PRIMARY };
}
